module.exports = __webpack_public_path__ + "static/media/SharedBlueNested.d1387068.svg";